// web/src/lib/agentTools.ts — shared tool catalogue for the agent creator/editor.
//
// id   = exact name registered in agents/_shared/tools/ (what the backend uses)
// label = human-readable name shown in the UI
export const AVAILABLE_TOOLS = [
    { id: "portfolio_optimizer", label: "Portfolio Optimizer" },
    { id: "portfolio_risk", label: "Risk & VaR" },
    { id: "portfolio_analysis", label: "Portfolio Analysis" },
    { id: "trade_signals", label: "Trade Signals" },
    { id: "market_data", label: "Market Data" },
    { id: "news_search", label: "News Search" },
    { id: "tax_calculator", label: "Tax Calculator" },
    { id: "tax_analysis", label: "Tax Analysis" },
    { id: "retirement_simulator", label: "Retirement Planner" },
    { id: "retirement_analysis", label: "Retirement Analysis" },
    { id: "insurance_calculator", label: "Insurance Calculator" },
    { id: "debt_analyzer", label: "Debt Analyzer" },
    { id: "cash_flow_analyzer", label: "Cash Flow Analyzer" },
    { id: "macro_data", label: "Macro Data" },
    { id: "fx_data", label: "FX Data" },
];
